import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="form-with-captcha"
export default class extends Controller {
  static targets = ["captcha", "submit"];
  static values = {
    sitekey: String,
  };

  async captchaTargetConnected(target) {
    this.submitTarget.disabled = true;

    this.widgetID = turnstile.render(target, {
      sitekey: this.sitekeyValue,
      theme: "light",
      callback: this.handleCaptchaComplete.bind(this),
      "expired-callback": this.handleCaptchaExpired.bind(this),
      "timeout-callback": this.handleCaptchaExpired.bind(this),
    });
  }

  captchaTargetDisconnected() {
    turnstile.reset(this.widgetID);
    turnstile.remove(this.widgetID);
  }

  handleCaptchaComplete() {
    this.submitTarget.disabled = false;
  }

  handleCaptchaExpired() {
    this.submitTarget.disabled = true;
  }
}
